const staticTranslations = {
  en: {
    global: {
      title: 'Cardholder Document Upload',
      chooseLanguage: 'Choose Language'
    },
    startScreen: {
      beginButton: 'Begin',
      chooseCategory: 'Choose a category below to route your document(s) to the correct department.',
      selectOption: 'Select an option to the left to see details and documents you can submit.'
    },
    uploadScreen: {
      instructionsTitle: 'Instructions',
      documentsYouCanUploadTitle: 'Documents You Can Upload',
      chooseOneOrMore: 'Choose one or more documents to upload.',
      addDocumentButton: 'Add Document',
      submitDocumentsButton: 'Submit Documents',
      uploadedDocuments: 'Uploaded Documents',
      documentIndex: 'Document',
      singleMultiModal: {
        title: 'Choose One',
        singlePageTitle: 'Single Page Document',
        singlePageDescription: 'Choose a single file or photo from your device.',
        multiPageTitle: 'Multi-page Document',
        multiPageDescription: 'Build a document with several pages from photos or files on your device.'
      },
      confirmDelete: {
        title: 'Delete Document?',
        yesButton: 'Yes',
        noButton: 'No'
      },
      presubmissionConfiration: {
        title: 'Are you sure that you uploaded all needed documents? This link will expire once you submit the documents.',
        yesButton: 'Yes, submit documents',
        noButton: 'Continue Uploading'
      },
      submissionModal: {
        uploading: 'Uploading',
        submissionComplete: 'Submission Complete!',
        confirmation: 'Confirmation',
        startNew: 'Start a New Upload',
        somethingWrong: 'Something went wrong...',
        tryAgain: 'Try Again'
      }
    },
    addDocumentScreen: {
      title: 'Add Document',
      finishButton: 'Finish Document'
    },
    addDocumentTray: {
      trayTitle: 'Edit Document',
      headerSubtitle: 'Choose one or more files/images to be included as pages in this document.\n Supported file types: PDF, TIFF, PNG, GIF, JFIF, JPG, .CSV, .XLSX, .TXT, and .DOC',
      finishButton: 'Complete'
    },
    documentPages: {
      headerTitle: 'Document Pages',
      addPageButton: 'Add Page',
      cancelButton: 'Cancel',
      pageIndex: 'Page',
      confirmDelete: {
        title: 'Delete Page?',
        yesButton: 'Yes',
        noButton: 'No'
      },
      addPage: {
        title: 'Add Page',
        choosePhotoButton: 'Choose Photo',
        takePicButton: 'Take a Picture',
        chooseFileButton: 'Choose File'
      },
      invalidFileType: 'The selected file type is not supported. Please upload one of the following PDF, TIFF, PNG, GIF, JFIF, JPG, .csv, .xlsx, .txt, or .doc',
    },
    errorScreen: {
      message: 'Something went wrong',
      tryAgain: 'Try Again'
    }
  },
  es: {
    global: {
      title: 'Carga de Documentos del Titular de Tarjeta',
      chooseLanguage: 'Elegir Idioma'
    },
    startScreen: {
      beginButton: 'Empezar',
      chooseCategory: 'Elige tu categoría a continuación para dirigir tu(s) documento(s) al departamento correcto.',
      selectOption: 'Selecciona una opción en la izquierda para ver los detalles y los documentos que puedes presentar.'
    },
    uploadScreen: {
      instructionsTitle: 'Instrucciones',
      documentsYouCanUploadTitle: 'Documentos que Puedes Cargar',
      chooseOneOrMore: 'Elige uno o más documentos para cargar.',
      addDocumentButton: 'Agregar Documento',
      submitDocumentsButton: 'Presentar Documentos',
      uploadedDocuments: 'Documentos Cargados',
      documentIndex: 'Documento',
      singleMultiModal: {
        title: 'Elige Uno',
        singlePageTitle: 'Documento de Una Sola Página',
        singlePageDescription: 'Elige un solo archivo o fotografía de tu dispositivo.',
        multiPageTitle: 'Documento de Varias Páginas',
        multiPageDescription: 'Crea un documento de varias páginas con fotos y archivos en tu dispositivo.'
      },
      confirmDelete: {
        title: '¿Eliminar el Documento?',
        yesButton: 'Sí',
        noButton: 'No'
      },
      presubmissionConfiration: {
        title: '¿Está seguro de que ha subido todos los documentos necesarios? Este enlace caducará una vez que envíe los documentos.',
        yesButton: 'Sí, subir documentos',
        noButton: 'Continuar cargando'
      },
      submissionModal: {
        uploading: 'Cargando',
        submissionComplete: '¡Presentación Completada!',
        confirmation: 'Confirmación',
        startNew: 'Empezar una Nueva Carga',
        somethingWrong: 'Algo salió mal...',
        tryAgain: 'Intentar otra vez'
      }
    },
    addDocumentScreen: {
      title: 'Agregar Documento',
      finishButton: 'Finalizar Documento'
    },
    addDocumentTray: {
      trayTitle: 'Editar Documento',
      headerSubtitle: 'Elige uno o más archivos o imágenes que se incluirán como páginas en este documento.\n Archivos soportados: PDF, TIFF, PNG, GIF, JFIF, JPG, .CSV, .XLSX, .TXT, y .DOC',
      finishButton: 'Completar'
    },
    documentPages: {
      headerTitle: 'Páginas del Documento',
      addPageButton: 'Agregar Página',
      cancelButton: 'Cancelar',
      pageIndex: 'Página',
      confirmDelete: {
        title: '¿Eliminar Página?',
        yesButton: 'Sí',
        noButton: 'No'
      },
      addPage: {
        title: 'Agregar Página',
        choosePhotoButton: 'Elegir Fotografía',
        takePicButton: 'Tomar una Fotografía',
        chooseFileButton: 'Elegir Archivo'
      },
      invalidFileType: 'El tipo de archivo seleccionado no es compatible. Por favor, sube uno de los siguientes tipos: PDF, TIFF, PNG, GIF, JFIF, JPG, .csv, .xlsx, .txt o .doc.'
    },
    errorScreen: {
      message: 'Algo salió mal',
      tryAgain: 'Intentar otra vez'
    }    
  }
};

export default staticTranslations;
